/**
 * @author yan st
 * @date 2026-07-24
 * @Description: 绩效管理、月报管理模块API
 */
import { qspost } from "@/plugins/axios";

/*
 *   获取项目列表（绩效管理/月报管理通用）
 *   organId=1 返回全部项目，其他返回自己机构的项目
 * */
export const getModuleProjectList = (pageIndex, pageSize) =>
  qspost("/api/Module/getProjectList", {
    pageIndex,
    pageSize,
  });

/*
 *   获取项目详情（绩效管理/月报管理通用）
 *   含合同文件七牛云真实地址
 * */
export const getModuleProjectDetail = (project_id) =>
  qspost("/api/Module/getProjectDetail", {
    project_id,
  });

/*
 *   获取月报列表（含当前可填报时间段）
 * */
export const getReportList = (project_id) =>
  qspost("/api/Module/getReportList", {
    project_id,
  });

/*
 *   保存月报（草稿/提交）
 *   is_save: 1=草稿, 0=提交
 * */
export const saveReport = (data) => qspost("/api/Module/saveReport", data);

/*
 *   获取项目绩效指标列表（按分类分组）
 * */
export const getRuleList = (project_id) =>
  qspost("/api/Module/getRuleList", {
    project_id,
  });

/*
 *   添加/编辑绩效指标（「其他」分类）
 * */
export const saveRule = (data) => qspost("/api/Module/saveRule", data);

/*
 *   保存项目合同（盖章扫描件）
 * */
export const saveProjectContract = (project_id, file_list) =>
  qspost("/api/Module/saveProjectContract", {
    project_id,
    file_list: JSON.stringify(file_list),
  });

/*
 *   保存指标填报记录（草稿/提交）
 *   is_save: 1=草稿, 0=提交
 * */
export const saveRuleRecord = (data) =>
  qspost("/api/Module/saveRuleRecord", data);

/*
 *   获取指标填报历史记录
 * */
export const getRuleRecordList = (rule_id) =>
  qspost("/api/Module/getRuleRecordList", {
    rule_id,
  });
